import { v4 as uuidv4 } from "uuid";

/**
 * The default Receipt # put in a desk payment form when it opens:
 * "RC-" and 8 random hex characters. Staff usually overwrite it with their
 * paper receipt number or initials, and may clear it to record none.
 *
 * One helper for every payment form (there were six copies). Generate it
 * once, when the form opens: the invoice and enrollment pages used to
 * generate a new one each time the payment method changed, so a Receipt #
 * staff had cleared came back on its own (2026-10-10).
 */
export function generateReceiptNumber(): string {
  return `RC-${uuidv4().split("-")[0].toUpperCase()}`;
}
